/* eslint-disable react/jsx-props-no-spreading */
import Icon from "../Icon";

const MapLocationDotSolidV6 = (props) => (
  <Icon {...props} name="Map Location Dot Solid V6">
    <path d="M11.333 4.222c0 1.517-2.031 4.219-2.922 5.308a.495.495 0 0 1-.822 0c-.892-1.089-2.922-3.792-2.922-5.308a3.333 3.333 0 1 1 6.666 0zM8 5.111a1.11 1.11 0 1 0 .001-2.22A1.11 1.11 0 0 0 8 5.11zm3.822.772a3.64 3.64 0 0 0 .042-.103l3.222-1.289A.666.666 0 0 1 16 5.11v7.522a.67.67 0 0 1-.419.619l-4.025 1.608V6.453c.097-.192.186-.381.267-.572zm-7.644 0c.081.192.169.381.267.572v6.983l-3.53 1.414c-.438.15-.914-.147-.914-.619V6.711c0-.272.166-.542.419-.619l3.403-1.361c.067.394.203.786.356 1.153zm4.928 4.203a23.25 23.25 0 0 0 1.561-2.114v6.925l-5.333-1.525v-5.4a23.394 23.394 0 0 0 1.561 2.114 1.383 1.383 0 0 0 2.211 0z" />
  </Icon>
);

export default MapLocationDotSolidV6;
